import { useEffect, useState } from "react";
import { Sun, Moon, LogOut, Search, ExternalLink } from "lucide-react";
import { useAuth } from "@/auth/useAuth.js";
import { PUBLIC_SITE } from "@/lib/site.js";

function getInitialTheme(): "light" | "dark" {
  if (typeof window === "undefined") return "dark";
  const stored = window.sessionStorage.getItem("theme");
  if (stored === "dark" || stored === "light") return stored;
  return "dark"; // default to the Payload-style dark theme
}

export function TopBar(): JSX.Element {
  const { signOut } = useAuth();
  const [theme, setTheme] = useState<"light" | "dark">(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    window.sessionStorage.setItem("theme", theme);
  }, [theme]);

  return (
    <header className="sticky top-0 z-30 flex h-[48px] items-center gap-4 border-b border-rule bg-bg/95 px-6 backdrop-blur">
      <div className="flex items-center gap-2 text-ink-soft">
        <Search className="size-4" />
        <input
          type="search"
          placeholder="Cerca immobili, inquiries, slug..."
          className="w-[320px] bg-transparent text-body outline-none placeholder:text-ink-mute"
        />
        <span className="hidden font-mono text-meta uppercase text-ink-mute md:inline">cmd+k</span>
      </div>

      <div className="ml-auto flex items-center gap-2">
        <a
          href={PUBLIC_SITE}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 rounded px-3 py-1.5 text-body text-ink-soft hover:bg-surface-2 hover:text-ink"
        >
          <ExternalLink className="size-4" />
          Vai al sito
        </a>
        <button
          type="button"
          onClick={() => setTheme(theme === "light" ? "dark" : "light")}
          aria-label="Cambia tema"
          className="rounded p-2 text-ink-soft hover:bg-surface-2 hover:text-ink"
        >
          {theme === "light" ? <Moon className="size-4" /> : <Sun className="size-4" />}
        </button>
        <button
          type="button"
          onClick={() => { void signOut(); }}
          className="flex items-center gap-2 rounded px-3 py-1.5 text-body text-ink-soft hover:bg-surface-2 hover:text-ink"
        >
          <LogOut className="size-4" />
          Esci
        </button>
      </div>
    </header>
  );
}
